// =============================================
// API CONFIGURATION
// =============================================
// TMDB API Key - Get free from: https://www.themoviedb.org/settings/api
// Google Books API Key - Get free from: https://console.cloud.google.com
// =============================================

export const CONFIG = {
  TMDB_API_KEY: "a2703262f631f18165d3a04c260d0a0b",         // Replace with your TMDB key
  GOOGLE_BOOKS_API_KEY: "YOUR_GOOGLE_BOOKS_KEY",   // Replace with your Google key (optional)
  TMDB_BASE_URL: "https://api.themoviedb.org/3",
  TMDB_IMAGE_BASE: "https://image.tmdb.org/t/p",
  GOOGLE_BOOKS_BASE: "https://www.googleapis.com/books/v1",
  WIKI_BASE: "https://en.wikipedia.org/api/rest_v1",
};
